import { useEffect, useState } from "react";

import { BLACK_HEX } from "constants/chart.constants";
import { useChartsContext } from "contexts";

import { useChartEntities } from "hooks/charts";

import { LegendItemModel } from "models";

import { createLegendItem } from "components/charts/utils";

const useLineOfBestFitLegendItems = (): LegendItemModel[] => {
  const { id } = useChartsContext();
  const { bestFitToggle: bestFitState, apiResponse } = useChartEntities(id);
  const [items, setItems] = useState<LegendItemModel[]>([]);
  const equation = apiResponse?.series?.find((s) =>
    s.label.includes("Line of Best Fit")
  )?.equation;
  const color = bestFitState?.properties?.color || BLACK_HEX;

  const isBestFitEnabled = Boolean(bestFitState?.active);
  useEffect(() => {
    if (!isBestFitEnabled || !equation) {
      setItems([]);
      return;
    }

    const legendItem = createLegendItem(`Line of Best Fit: ${equation}`, true, color);

    setItems([legendItem]);
  }, [isBestFitEnabled, bestFitState?.properties, equation]);

  return items;
};

export default useLineOfBestFitLegendItems;
